// Modified GraphicNovelEditor.tsx - Now using SketchedCanvasInterface
import React from 'react';
import { ProjectProvider } from './context/ProjectContext';
import { ToolProvider } from './context/ToolContext';
import SketchedCanvasInterface from './components/Canvas/SketchedCanvasInterface';

const GraphicNovelEditor: React.FC = () => {
  return (
    <ProjectProvider>
      <ToolProvider>
        <SketchedCanvasInterface />
      </ToolProvider>
    </ProjectProvider>
  );
};

export default GraphicNovelEditor;
